import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import WebFont from 'webfontloader';
import Container from './elements/Container';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import SignUp from './components/SignUp';
import { Helmet } from 'react-helmet';
import favicon from "./assets/img/favicon.ico";
import Background from './elements/Backgroud';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import { ProviderToggle } from './context/ContextToggle';
import { ProviderAlert } from './context/ContextAlert';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import RegisterSale from './components/RegisterSale';
import ProductForm from './components/ProductManagment';
import CategoriesForm from './components/Categories';
import SupplierManagment from './components/SupplierManagment';
import Sales from './components/Sales';
import StockManagment from './components/StockManagment';
import Items from './components/Items';
import Expense from './components/Expense'
import PaymentPlan from './components/PaymentPlan'


WebFont.load({
  google: {
    families: ['Montserrat', 'sans-serif']
  }
})


const Index = () => {
  return (
    <>
      <Helmet>
        <link rel="shortcut icon" href={favicon} type="image/x-icon" />
        <title>
          Inicio
        </title>
      </Helmet>
      <AuthProvider>
        <Header></Header>
        <BrowserRouter>
          <Container>
            <Routes>
              <Route path="/inicio-sesion" element={<Login />} />
              <Route path="/registro" element={<SignUp />} />
              <Route path="/registrar-venta" element={
                <PrivateRoute>
                  <RegisterSale />
                </PrivateRoute>
              } />
              <Route path="/creacion-producto" element={
                <PrivateRoute>
                  <ProductForm />
                </PrivateRoute>
              } />
              <Route path="/categorias" element={
                <PrivateRoute>
                  <CategoriesForm />
                </PrivateRoute>
              } />

              <Route path="/proveedores" element={
                <PrivateRoute>
                  <SupplierManagment />
                </PrivateRoute>
              } />
              <Route path="/resumen-ventas" element={
                <PrivateRoute>
                  <Sales />
                </PrivateRoute>
              } />
              <Route path="/stock" element={
                <PrivateRoute>
                  <StockManagment />
                </PrivateRoute>
              } />
                   <Route path="/items" element={
                <PrivateRoute>
                  <Items />
                </PrivateRoute>
              } />
               <Route path="/registro-gasto" element={
                <PrivateRoute>
                  < Expense/>
                </PrivateRoute>
              } />
                    <Route path="/payment-plan" element={
                <PrivateRoute>
                  < PaymentPlan/>
                </PrivateRoute>
              } />
              <Route path="/" element={
                <PrivateRoute>
                  <App />
                </PrivateRoute>
              } />
            </Routes>
          </Container>
        </BrowserRouter>
        <Background />
      </AuthProvider>
    </>
  );
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ProviderAlert>
        <ProviderToggle>
          <Index />
        </ProviderToggle>
      </ProviderAlert>
    </AuthProvider>
  </React.StrictMode>
);

